// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"authHeading_wrapper__149gu","planYearLogo":"authHeading_planYearLogo__BSQzL"};